require('./bundle-manifest').register(JSON.parse("{\"KoI75\":\"index.32f40f5a.js\",\"7C0qf\":\"logo.29e75042.svg\",\"7fdGU\":\"index.1257c75f.css\"}"));